import React, {useEffect, useRef, useState} from "react"
import {Body1} from "../../components/Font";
import {
    ActiveListItem,
    DropIconContainer,
    ListItem,
    ListItemContainer,
    SelectContainer,
    SelectDownList,
    SelectHeader,
    SelectIconContainer,
    SelectListContainer
} from "../../components/ui/Select";
import {InputSearch} from "../Input/InputSearch";
import {InputStringError} from "../../components/ui/InputSearch";
import {IFilter, WindowSizePXEnum} from "../../interface/Basic/window";
import {useOnClickOutside} from "../../hooks/useClickOutside";
import {Clear, DropDown, DropUp} from "../../icon/Icon";
import {useTheme} from "styled-components";


/*Выпадающий список с одиночным выбором*/
export interface SelectProps {
    data: IFilter[]
    selectedValue: number | null | undefined
    onSelect: (id: number, value?: string) => void
    onClean?: () => void
    onOpen?: () => void
    closeOnSelect?: boolean
    isCleanable?: boolean
    isSearchable?: boolean
    placeholder?: string
    disabled?: boolean
    contentHeight?: string
    error?: string
    getSearchValue?: (value: string) => void
    className?: string
}

export const Select = ({
                           data,
                           onSelect,
                           onClean,
                           onOpen,
                           selectedValue,
                           isCleanable,
                           isSearchable,
                           placeholder,
                           disabled,
                           contentHeight,
                           error,
                           getSearchValue,
                           className
                       }: SelectProps): React.ReactElement => {

    const [isOpen, setIsOpen] = useState(false)
    const [filter, setFilter] = useState('')
    const Theme = useTheme()
    const ref = useRef<HTMLDivElement>(null);
    useOnClickOutside(ref, () => setIsOpen(false));
    const toggle = () => setIsOpen(!isOpen);

    useEffect(() => {
        if (isOpen && onOpen) {
            onOpen()
        }
        if (!isOpen) {
            document.querySelector('.selectHeader')?.classList.remove('selectHeader')
            setFilter('')
        }
    }, [isOpen])

    const headerText = data.find(i => i.id === selectedValue)?.name

    const filteredData = data.filter(i => {
        return i.name.toLowerCase().split(' ').join('').includes(filter.toLowerCase().trim())
    })
    const [contentCoords, setContentCoords] = useState({
        top: 0,
        left: 0
    })
    const [contentWidth, setContentWidth] = useState(0)

    useEffect(() => {
        const resizer = () => {
            const header = document.querySelector('.selectHeader')
            if (header) {
                if (window.screen.availWidth <= parseInt(WindowSizePXEnum.xs) && (className === 'mobile' || className === 'career-year')) {
                    setContentCoords({
                        top: header.getBoundingClientRect().bottom + 273,
                        left: header.getBoundingClientRect().left
                    })
                } else {
                    setContentCoords({
                        top: header.getBoundingClientRect().bottom + 3,
                        left: header.getBoundingClientRect().left
                    })
                }

            }
        }
        window.addEventListener("resize", resizer)
        window.addEventListener('scroll', resizer)
        return () => {
            window.removeEventListener('scroll', resizer)
            window.removeEventListener("resize", resizer);
        }
    }, []);

    return <SelectContainer className={className}>
        <div
            ref={ref}
            onClick={(e) => {
                if (!e.currentTarget.className.includes('selectHeader')) {
                    e.currentTarget.classList.add('selectHeader')
                }
                if ((window.screen.availHeight <= 1100 || window.screen.availWidth <= parseInt(WindowSizePXEnum.xs)) && (className === 'mobile' || className === 'career-year')) {
                    setContentCoords({
                        top: e.currentTarget.getBoundingClientRect().bottom - 273,
                        left: e.currentTarget.getBoundingClientRect().left
                    })
                } else {
                    setContentCoords({
                        top: e.currentTarget.getBoundingClientRect().bottom + 3,
                        left: e.currentTarget.getBoundingClientRect().left
                    })
                }
                setContentWidth(e.currentTarget.offsetWidth)

                toggle()
            }}>
            <SelectHeader error={error} style={{
                height: '56px',
                pointerEvents: disabled ? "none" : "initial",
                filter: disabled ? 'opacity(40%)' : "none",
            }}>
                {placeholder && !selectedValue &&
                    <Body1 color={'rgba(137, 143, 151, 1)'}>
                        {placeholder}
                    </Body1> ||
                    <Body1>
                        {headerText}
                    </Body1>
                }
                <DropIconContainer>
                    {isOpen ? <DropUp/> : <DropDown/>}
                </DropIconContainer>

            </SelectHeader>
            {isOpen && <SelectListContainer>
                <SelectDownList style={{
                    top: `${contentCoords.top.toString()}px`,
                    left: `${contentCoords.left.toString()}px`,
                    width: `${contentWidth.toString()}px`,
                }}>
                    {isSearchable && <InputSearch onChange={(value: string) => {
                        setFilter(value)
                        getSearchValue && getSearchValue(value)
                    }}/>}
                    <ListItemContainer
                        style={{maxHeight: contentHeight ? contentHeight : '200px'}}>
                        {filteredData.map((item, index) => {
                            return <ListItem key={index}
                                             as={item.id === selectedValue ? ActiveListItem : ListItem}
                                             onClick={() => {
                                                 onSelect(item.id, item.value)
                                                 setIsOpen(false)
                                             }}>
                                <Body1>
                                    {item.name}
                                </Body1>
                            </ListItem>
                        })}</ListItemContainer>
                    {filter !== '' && filteredData.length === 0 && <ListItem>
                        <Body1 color={Theme.color.secondary}>Ничего не найдено</Body1>
                    </ListItem>}
                </SelectDownList>
            </SelectListContainer>}
        </div>
        <InputStringError error={error}>{error}</InputStringError>
        {selectedValue !== null && isCleanable && selectedValue !== -1 &&
            <SelectIconContainer onClick={() => onClean && onClean()}>
                <Clear/>
            </SelectIconContainer>}
    </SelectContainer>
}
